<template>
  <v-content>
    <v-container fluid fill-height grid-list-lg wrap class="py-2 pl-3 pr-0">
      <v-layout :column="$vuetify.breakpoint.xsOnly">
        <!--  
                            database-overview

                            The database overview pane can be hidden by clicking the list icon
                            on the editor tab pane.

                            We also set the height and width based on the breakpoint. This could be
                            done with pure CSS media queries, but vuetify provides us the means to 
                            do it right here with JS.
                        -->

        <!-- Vertical navbar -->
        <!-- Admin Navbar -->
          <div v-if="adminMenuAvailable && !this.$route.name.includes('selfservice')" class="vertical-nav bg-white" id="sidebar">
          <div class="py-2 px-3 bg-light">
            <div class="media d-flex align-items-center">
              <div class="media-body">
                <h2 class="mb-0">{{$t('transact2hrmenu')}}</h2>
              </div>
            </div>
          </div>
          <app-menu />
        </div>

        <!-- Non Admin Self Service Navbar -->
        <div v-else class="vertical-nav bg-white" id="sidebar">
          <div class="ml-4 mr-4 mt-4">
            <v-card class="mb-8">
              <v-row>
                <v-col cols="6" sm="6" md="6">
                  <v-img 
                    v-if="this.personPic"
                    class="ml-2 mr-n4 rounded-circle"  
                    :src="this.personPic">
                  </v-img>
                  <v-img 
                    v-else
                    class="ml-2 mr-n4 rounded-circle"  
                    :src="`${publicPath}images/avatar-1577909_960_720.png`">
                  </v-img>
                </v-col>
                <v-col cols="6" sm="6" md="6">
                  <v-row class="mt-3 mb-3 ml-2 mr-2">
                    <p style="font-size: 14px">{{`${this.$t('selfservicescreen.welcome')}, ${personName}`}}</p>
                  </v-row>
                  <v-row>
                    <v-col cols="6" sm="6" md="6"></v-col>
                    <v-col cols="6" sm="6" md="6">
                      <div class="mt-4 mb-2 mr-2">
                        <v-icon @click="backHome()"> mdi-home </v-icon>
                      </div>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
            <v-card>
              <v-row class="ml-4 pb-4 mr-4">
               <app-menu-selfservice />
              </v-row>
            </v-card>
          </div>
        </div>
        <!-- End vertical navbar -->

        <!-- Page content holder -->
        <div class="page-content px-5" id="content" style="margin-top: 110px">
  <div
    style="position: relative; width: 100%; display: flex; align-items: center; gap: 1rem;"
  >
    <!-- Profile Button -->
    <v-btn
      v-if="adminMenuAvailable && !this.$route.name.includes('selfservice')"
      id="sidebarCollapse"
      type="button"
      class="btn btn-light bg-white rounded-pill shadow-sm px-4 mt-2"
      @click="toggleClass()"
    >
      <v-icon small class="mr-2">mdi-menu</v-icon>
      <small class="text-uppercase font-weight-bold">{{$t('Menu')}}</small>
    </v-btn>

    <v-btn
      v-else
      id="sidebarCollapse"
      type="button"
      class="btn btn-light bg-white rounded-pill shadow-sm px-4 mt-2"
      @click="toggleClass()"
    >
      <v-icon small class="mr-2">mdi-account</v-icon>
      <small class="text-uppercase font-weight-bold">{{$t('settingsswitchprofilemobile.profile')}}</small>
    </v-btn>

    <!-- KPI and Review Buttons -->
    <!-- <div
      v-if="['selfservice/performance', 'selfservice/review', 'selfservice/kpi'].some(name => $route.name.includes(name))" style="display: flex; gap: 0.5rem; align-items: center; margin-top: 10px;"
    > -->
    <div v-if="this.$route.name.includes('selfservice') && (this.$route.name.includes('performance') || this.$route.name.includes('review') || this.$route.name.includes('kpi') || this.$route.name.includes('mystaff'))"
      style="display: flex; gap: 0.5rem; align-items: center; margin-top: 10px;">
      <button class="btn shadow-sm px-4" :style="($route.path.includes('/kpi') || $route.path.includes('/performance')) ? 'background-color: #1261a0; color: white;' : 'background-color: #f8f9fa; color: black;'" @click="goToPage('kpi')">
        <v-icon small class="mr-2" :style="($route.path.includes('/kpi') || $route.path.includes('/performance')) ? 'color: white;' : 'color: black;'">mdi-file-document</v-icon>
        KPI
      </button>
      <button class="btn shadow-sm px-4" :style="($route.path.includes('/review')) ? 'background-color: #1261a0; color: white;' : 'background-color: #f8f9fa; color: black;'" @click="goToPage('review')">
        <v-icon small class="mr-2" :style="($route.path.includes('/review')) ? 'color: white;' : 'color: black;'">mdi-tune</v-icon>
        Review
      </button>
      <button class="btn shadow-sm px-4" :style="($route.path.includes('/mystaff')) ? 'background-color: #1261a0; color: white;' : 'background-color: #f8f9fa; color: black;'" @click="goToPage('mystaff')">
        <v-icon small class="mr-2" :style="($route.path.includes('/mystaff')) ? 'color: white;' : 'color: black;'">mdi-account-group</v-icon>
        My Staff
      </button>
    </div>
  </div>

  <div style="position: relative" class="mt-5">
    <router-view />
  </div>
</div>


      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import Menu from "./components/common/Menu";
import MenuSelfService from "./components/common/MenuSelfService";

// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.min.js";
// import "jquery/dist/jquery.slim.min.js";
// import "popper.js/dist/umd/popper.min.js";
import "jquery/dist/jquery.min.js";
import $ from "jquery";
export default {
  components: {
    "app-menu": Menu,
    "app-menu-selfservice": MenuSelfService,
  },

  data() {
    return {
      publicPath: process.env.BASE_URL,
      showMenuOverview: true,
      adminMenuAvailable: null,
      personName: null,
      personPic: null,
    };
  },

  // watch : {
  //   currentPath() {
  //     console.log(this.$route);
  //   }
  // },

  methods: {
    toggleClass() {
      // $("#sidebarCollapse").on("click", function () {
      $("#sidebar, #content").toggleClass("active");
      // });
    },

    goToPage(performancetype) {
      if(performancetype == 'kpi') {
        this.$router.push({ name: "selfserviceperformance" });
      } else if (performancetype == 'review') {
        this.$router.push({ name: "selfservicereview"});
      } else {
        this.$router.push({ name: "selfservicemystaff"});
      }
      // this.$router.push({ name: "selfserviceperformance", params: {performancetype: performancetype} });
    },
    
    backHome() {
      this.$router.push({name: 'selfservicehome'});
    }
  },

  mounted() {

    // Check if admint or not
    this.adminMenuAvailable = this.$store.getters.userType == 1 ? true : false;
    // console.log("Admin ?", this.adminMenuAvailable);
    // console.log("Current Route Name:", this.$route.name);
    // console.log("Includes 'selfservice'?", this.$route.name.includes('selfservice'));

    // Assign Person Name
    this.personName = this.$store.getters.personName;

    // Assign Person Pic
    this.personPic = this.$store.getters.personPic;

    //toggle sidebar
    // $("#sidebarCollapse").on("click", function () {
    //   $("#sidebar, #content").toggleClass("active");
    // });

  },
};
</script>